import { faBuildingUser, faCheck, faEdit, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { HateoasResource } from '@lagoshny/ngx-hateoas-client';
import { TranslateService } from '@ngx-translate/core';
import { CompanyOwned } from 'src/app/models/company/company-models.model';
import { Status } from 'src/app/shared/models/status.model';
import { InspectionListView } from './dto/inspection-list-view.model';
import { EmbeddedInspectionList } from './embedded-inspection-list/inspection-embedded-list.model';
import { InspectionElement } from './inspection-element.model';
import { InspectionLayer } from './inspection-layer.model';
import { Label } from './label.model';
import { Labeled } from './labeled.model';
import { MeasuringPoint } from './measuring-point.model';

export enum InspectionStatus {
  IN_PROGRESS = 'inuitvoering',
  CONCEPT = 'concept',
  DEFINITIVE = 'definitief',
  ARCHIVE = 'archief',
}

export const inspectionStatuses = (translateService?: TranslateService) =>
  [
    {
      value: InspectionStatus.IN_PROGRESS,
      label: translateService?.instant(`statuses.${InspectionStatus.IN_PROGRESS}`),
      icon: faBuildingUser,
      severity: 'in-progress-status',
    },
    {
      value: InspectionStatus.CONCEPT,
      label: translateService?.instant(`statuses.${InspectionStatus.CONCEPT}`),
      icon: faEdit,
      severity: 'concept-status',
    },
    {
      value: InspectionStatus.DEFINITIVE,
      label: translateService?.instant(`statuses.${InspectionStatus.DEFINITIVE}`),
      icon: faCheck,
      severity: 'definitive-status',
    },
    {
      value: InspectionStatus.ARCHIVE,
      label: translateService?.instant(`statuses.${InspectionStatus.ARCHIVE}`),
      icon: faTrash,
      severity: 'archive-status',
    },
  ] as Status<InspectionStatus>[];

export enum InspectionType {
  MEASURING_POINT = 'open',
  STRUCTURE = 'inspectie',
  DETAIL = 'detail',
}

export interface InspectionSignature {
  name: string;
  fileId: string;
}

@HateoasResource('inspection')
export class Inspection extends CompanyOwned implements Labeled {
  public naam!: string;
  public label: string | null = null;
  public datum!: Date;
  public inspecteur!: string;
  public inspectielijst!: string;
  public inspectietype!: InspectionType;
  public rgsObjectId!: string;
  public opmerkingen!: string;
  public score!: string;
  public status!: InspectionStatus;
  public labels: Label[] = [];
  public signature: InspectionSignature | null = null;
  public meetplaatsen: MeasuringPoint[] = [];
  public lagen: InspectionLayer[] = [];
  public elementen: InspectionElement[] = [];
  public embeddedInspectionList!: EmbeddedInspectionList;
  public pricebookId!: string;

  public static inspectionListViewMap(inspectionListView: InspectionListView) {
    const inspection = new Inspection();

    inspection.id = inspectionListView.id;
    inspection.naam = inspectionListView.name;
    inspection.bedrijf = inspectionListView.license;
    inspection.datum = new Date(inspectionListView.date);
    inspection.inspecteur = inspectionListView.inspector;
    inspection.inspectietype = inspectionListView.inspectionType;
    inspection.rgsObjectId = inspectionListView.rgsObjectId;
    inspection.status = inspectionListView.status;

    return inspection;
  }
}
